import { css } from "@emotion/react";

export const container = css`
  position: relative;
  width: 100%;
`;

export const background = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  width: 100vw;
  height: 100vh;
  z-index: -1;
  filter: blur(0);

  ::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(10px);
  }

  * {
    object-fit: cover;
    width: 100vw !important;
    height: 100vh !important;
  }
`;
